<template>
  <div class="portlet light">
    <div class="row">
      <div class="col-xs-12 col-md-6 col-md-offset-3">
        <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
          <div class="text-center ss-titre">
            <strong>Images d'accueil</strong>&nbsp;-&nbsp;<em class="text-center" style="font-size: 11px;">jpg ou png acceptés uniquement</em>
          </div>
           <v-image-upload
              :key="imageKey"
              :oldImage="selectedImage"
              name="office"
              :display="false"
              @image="addNewImage"
              @validated="sendImage">
          </v-image-upload>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="ss-titre">
        <span class="font-red-sunglo uppercase bold">Images ajoutées :</span>
      </div>
      <div class="portlet-body">
        <div class="portlet light">
          <!-- Image Cards -->
          <div class="mt-element-card mt-element-overlay" v-for="(image, index) in oldImages">
            <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12">
              <div class="mt-card-item boxShadowGreen">
                <div class="mt-card-avatar mt-overlay-1" style="background-color: #C7C89E;">
                  <img :src="`/${image.optimized}`" class="containCardImg">
                  <div class="mt-overlay">
                    <button class="btn btn-danger btn-outline btnCard pull-right btnRadius" @click="deleteImage(image, index)">
                        <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- End Image Cards -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'CarouselForm',
  props: {
    images: {
      type: Array,
      default : () => {
        return []
      }
    },
    office: {
      type: Object
    }
  },
  data () {
    return {
      selectedImage: {},
      oldImages: Object.assign([], this.images),
      newImage: new vImageHelper(),
      imageKey: 0
    }
  },
  methods: {
    addNewImage(event) {
        this.newImage.add(event)
    },
    async deleteImage(image, index) {
      this.$delete(this.oldImages, index)
      await axios.delete(`/office/${this.office.id}/image/${image.id}/office`)
      this.$snotify.success("L'image a bien été supprimée")
    },
    sendImage() {
      this.newImage.send(`/office/${this.office.id}/image/office`, () => {
        this.oldImages.push(this.newImage.response.image)

        this.selectedImage = {}

        this.imageKey += 1
      })

    }
  }
};
</script>

<style lang="css" scoped>
</style>
